import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { PageHeaderReturnLink } from 'teacher-ui-client/components/page-header/return-link'
import { t } from 'ember-intl'
import { AssignmentForm } from 'teacher-ui-client/components/assignments-admin/assignment-form'
import type AssignmentsProductCreateRoute from 'teacher-ui-client/assignments/product/create/route'
import type AssignmentsProductCreateController from 'teacher-ui-client/assignments/product/create/controller'

interface Signature {
  Args: {
    model: ModelFor<AssignmentsProductCreateRoute>
    controller: AssignmentsProductCreateController
  }
}

export const AssignmentsProductCreateTemplate: TOC<Signature> = <template>
  <div class="m-0 w-full grow">
    <PageHeader>
      <:title>
        <h1>
          {{t "assignments.create.title"}}
        </h1>
      </:title>
      <:left>
        <PageHeaderReturnLink @route="assignments.product.manage.current">
          {{t "assignments.backToManage"}}
        </PageHeaderReturnLink>
      </:left>
    </PageHeader>

    <p class="mb-3 text-center">
      {{t "assignments.form.lockoutWarning"}}
    </p>

    <AssignmentForm
      class="mt-8"
      @subscriptionType={{@model.subscriptionType}}
      @teachers={{@model.teachers}}
      @students={{@model.students}}
      @assignmentProduct={{@model.assignmentProduct}}
    />
  </div>
</template>

export default RouteTemplate(AssignmentsProductCreateTemplate)
